module.exports = __webpack_public_path__ + "static/media/产品优势-数字孪生可视化系统.9a4ff143.jpg";